import { Cancel } from "@mui/icons-material";
import { Stack, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useRef } from "react";

const Tags = ({ data, handleDelete }) => {
  return (
    <Box
      sx={{
        background: "#283240",
        height: "100%",
        display: "flex",
        padding: "0.4rem",
        margin: "0 0.5rem 0 0",
        justifyContent: "center",
        alignContent: "center",
        color: "#ffffff",
      }}
    >
      <Stack direction='row' gap={1}>
        <Typography>{data}</Typography>
        <Cancel
          sx={{ cursor: "pointer" }}
          onClick={() => {
            handleDelete(data);
          }}
        />
      </Stack>
    </Box>
  );
};

export default function TagsInput(props) {
  const tagRef = useRef();

  const handleDelete = (value) => {
    if(props.setTags !== undefined) {
      const newtags = props.tags.filter((val) => val !== value);
      props.setTags(newtags);
    }
  };

  const handleOnKeyDown = (e) => {
    if ((e.keyCode === 9 || e.keyCode === 188 || e.keyCode === 13 || e.keyCode === 32) && e.target.value !== "" && ((props?.email !== undefined && props.email === true) ? validateEmail(e.target.value) : true)) {
      e.preventDefault();
      if(props.setTags !== undefined) {
        props.setTags([...props.tags, tagRef.current.value]);
      }    
      tagRef.current.value = "";
    } else if (e.keyCode === 8) {
      if (props.tags.length > 0) {
        handleDelete(props.tags.slice(-1)[0]);
      }      
    }
  };

  const validateEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };

  return (<Box sx={{ flexGrow: 1 }}>
    <TextField
      inputRef={tagRef}
      fullWidth
      variant='outlined'
      margin='none'
      label={props.label}
      onKeyDown={handleOnKeyDown}
      className={`tags-input-area ${props?.className || ""}`}
      disabled={props?.disabled}
      InputProps={{ startAdornment: (
        <Box sx={{ margin: "0 0.2rem 0 0", display: "flex" }}>
          {props.tags.map((data, index) => {
            return (
              <Tags data={data} handleDelete={handleDelete} key={index} />
            );
          })}
        </Box>
      )}}
    />
  </Box>);
}